﻿import { apiPromise, htmlPromise } from '../../../../Resources/Scripts/_Shared/fetch'
import { mockedData } from './MockedData'

export const facility = {
  getNearbyFacilities: async (data) => apiPromise('/booking/getnearbyfacilities', data).catch((err) => err),
  getConfirmationPageOffers: async (data) => htmlPromise('/facilitypage/getconfirmationpageoffer', data).catch((err) => err),
  getFacility: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/products`).catch((err) => err) : apiPromise(`${data.bookingController}getfacilitysummary`, data).catch((err) => err),
}

export const products = {
  getProducts: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/products`).catch((err) => err) : apiPromise(`${data.bookingController}getfacilitysummary`, data).catch((err) => err),
  getAvailability: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/availability`).catch((err) => err) : apiPromise(`${data.bookingController}getavailableslots`, data).catch((err) => err),
  getParkingSpaceAvailability: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/parkingpaceavailability`).catch((err) => err) : apiPromise(`${data.bookingController}getparkingspaceavailability`, data).catch((err) => err),

  getAccessDeviceAvailability: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/accessdeviceavailability`).catch((err) => err) : apiPromise(`/booking/getaccessdeviceavailability`, data, 'POST').catch((err) => err),
  createSalesOrderDraft: async (data, mocked, lang) => mocked ? apiMockedPromise(`/bookingflow/createsalesorderdraft`).catch((err) => err) : apiPromise(`/booking/createsalesorderdraft`, data, lang, 'POST').catch((err) => err),
  updateSalesOrder: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/updatesalesorder`, data).catch((err) => err) : apiPromise(`${data.bookingflowPage}updatesalesorder`, data.form, 'POST').catch((err) => err),
  confirmSalesOrder: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/confirmsalesorder`, data).catch((err) => err) : apiPromise(`${data.bookingflowPage}confirmsalesorder`, data.form, 'POST').catch((err) => err),

  getPaymentOptions: async (mocked) => mocked ? apiMockedPromise(`/bookingflow/paymentoptions`).catch((err) => err) : apiPromise(`${data.bookingflowPage}paymentoptions`).catch((err) => err),
  getFlexbookingPrice: async (data, mocked, lang) => mocked ? apiMockedPromise(`/bookingflow/getflexbookingprice`, data).catch((err) => err) : apiPromise(`${data.bookingController}getflexbookingprice`, data, lang).catch((err) => err),
}

export const account = {
  getLoggedInUser : async (mocked) => mocked ? apiMockedPromise(`/bookingflow/loggedincustomer`).catch((err) => err) : apiPromise(`${data.bookingflowPage}loggedincustomer`).catch((err) => err),
  createOrEditCustomer : async (data, mocked, lang) => mocked ? apiMockedPromise(`/bookingflow/createoreditcustomer`).catch((err) => err) : apiPromise(`${data.bookingController}createoreditcustomer`, data.form, lang, 'POST').catch((err) => err),
  updateAccount : async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/updatecustomer`).catch((err) => err) : apiPromise(`${data.bookingflowPage}updatecustomer`, data.form, 'POST').catch((err) => err),
}

export const vehicles = {
  getCustomerVehicles: async (data, mocked, lang) => mocked ? apiMockedPromise(`/bookingflow/getvehicles`).catch((err) => err) : apiPromise(`${data.bookingController}getvehicles`, null, lang).catch((err) => err),
  createCustomerVehicle: async (data, mocked, lang) => mocked ? apiMockedPromise(`/bookingflow/createvehicle`).catch((err) => err) : apiPromise(`${data.bookingController}createvehicle`, data.form, lang, 'POST').catch((err) => err),
}

export const tempLock = {
  createTempLock: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/createtempLock`).catch((err) => err) : apiPromise(`/booking/createtemplock`, data, 'POST').catch((err) => err),
  removeTempLock: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/removetempLock`).catch((err) => err) : apiPromise(`/booking/removetempLock`, data, 'POST').catch((err) => err),
  updateTempLock: async (data, mocked) => mocked ? apiMockedPromise(`/bookingflow/updatetempLock`).catch((err) => err) : apiPromise(`/booking/updatetempLock`, data, 'POST').catch((err) => err),
}

export const payment = {
  getCreditcardPaymentUrl : async (data, mocked) => mocked ? apiMockedHtmlPromise(`/bookingflow/registerpayment`).catch((err) => err) : htmlPromise(`${data.bookingflowPage}registerpayment`, data.form, 'POST').catch((err) => err),
}

export const test = {
  getTestCall: async (data, returnTime = 3000) => {
    return new Promise((resolve) => {
      console.log(`Test call (${returnTime}ms). Data: `, data)

      setTimeout(() => {
        resolve({ status: 200, info: 'OK', body: 'Test call (3000ms)' });
      }, returnTime);
    });
  },
}

const apiMockedPromise = (url, data = {}, returnTime = 0) => {
  return new Promise((resolve) => {
    let returnData;
    let status = 200;
    let info = 'OK';
    //let returnTime = 3000; //Milliseconds

    if(url.lastIndexOf('/bookingflow/facility', 0) === 0)
      returnData = mockedData.facility;
    else if(url.lastIndexOf('/bookingflow/products', 0) === 0)
      returnData = mockedData.products;
    else if(url.lastIndexOf('/bookingflow/availability', 0) === 0)
      returnData = { Availability: Math.floor(Math.random() * 6) + 1 }, returnTime = 2000;
    else if(url.lastIndexOf('/bookingflow/parkingpaceavailability', 0) === 0) {
      //const mockedReturnData = [[], mockedData.parkingSpaceAvailability];
      returnData = mockedData.parkingSpaceAvailability, returnTime = 2000; //mockedReturnData[Math.floor(Math.random() * mockedReturnData.length)], returnTime = 2000;
    }
    else if(url.lastIndexOf('/bookingflow/getflexbookingprice', 0) === 0) {
      var date1 = new Date(data.startDate);
      var date2 = new Date(data.endDate);
      var Difference_In_Time = date2.getTime() - date1.getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      returnData = new Intl.NumberFormat({ maximumFractionDigits: 2, style: 'currency' }).format((Difference_In_Days * 100)) + ' SEK', returnTime = 2000;
    }
    else if(url.lastIndexOf('/bookingflow/paymentoptions', 0) === 0)
      returnData = mockedData.paymentoptions;
    else if(url.lastIndexOf('/bookingflow/getvehicles', 0) === 0)
      returnData = mockedData.userVehicleList;
    else if(url.lastIndexOf('/bookingflow/createcustomer', 0) === 0)
      returnData = mockedData.userInformation, returnTime = 3000;
    else
      returnData = 'No mocked api endpoint match!'

    console.log(`Mocked data: ${url}, data: `, data, { status: 200, info: 'OK', body: returnData })

    setTimeout(() => {
      resolve({ status, info, body: returnData });
    }, returnTime === 0 ? (Math.floor(Math.random() * 5) * 1000) : returnTime);
  });
}

const apiMockedHtmlPromise = (url, data = {}, returnTime = 0) => {
  return new Promise((resolve) => {
    let returnData;
    let status = 200;
    let info = 'OK';
    //let returnTime = 3000; //Milliseconds

    if(url.lastIndexOf('/bookingflow/registerpayment', 0) === 0)
      returnData = '"https://test.epayment.nets.eu/Terminal/default.aspx?merchantId=12003812&transactionId="';
    else
      returnData = 'No mocked api endpoint match!'

    console.log(`Mocked data: ${url}, data: `, data, { status: 200, info: 'OK', body: returnData })

    setTimeout(() => {
      resolve({ status, info, body: returnData });
    }, returnTime === 0 ? (Math.floor(Math.random() * 5) * 1000) : returnTime);
  });
}